import { createStyles, Grid, makeStyles } from "@material-ui/core";
import Dialog from "components/Dialog";
import Table from "components/Table";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import { useDefaultRowParcel } from "domains/Task/types/Column";
import { SubTask } from "generated/graphql";
import "styled-components/macro";
import React from 'react';
import { ROW_PER_PAGE_OPTIONS } from "config";

export interface ShowTaskParcelProps {
  open: boolean;
  handleClose: () => void;
  task?: SubTask;
}
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
    },
    top: {
      display: "flex",
      marginBottom: 10,
    },
    caisse: {
      width: 58,
      height: 58,
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
      opacity: 0.6,
      borderRadius: 18,
      marginRight: 12.5,
    },
    name: {
      fontSize: 12,
      fontWeight: 500,
      color: "#707070",
      paddingTop: 10,
    },
    type: {
      fontSize: 21,
      fontWeight: 800,
      color: "#399ebf",
    },
    nameContent: {
      display: "flex",
      flexDirection: "column",
    },
    detail: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      justifyContent: "space-between",
    },
    time: {
      color: "#707070",
      fontSize: 14,
      marginLeft: 12.5,
      marginTop: 15,
    },
    number: {
      color: "#707070",
      fontSize: 14,
      marginLeft: 12.5,
    },
    bloc: {
      display: "flex",
      width: "100%",
    },
    icon: {
      marginLeft: 2,
    },
    title: {
      color: COLORS.primary,
    },
  })
);
export function ShowTaskParcel({ open, handleClose, task }: ShowTaskParcelProps) {
  const styles = useStyles();
  const { text } = useText();
  const [page, setPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const DefaultRowParcel = useDefaultRowParcel();

  const handleCloseModal = () => {
    handleClose();
  };

  return (
    <Dialog
      title={text.all.parcels}
      open={open}
      handleClose={handleCloseModal}
      maxWidth="lg"
      key="add user dialog"
      cancelButtonTitle={text.all.cancel}
    >
      <Grid container direction="row" className={styles.root}>
        <Grid item xs={12} style={{ height: 300 }}>
          <Table rowsIdentifier="_id" columns={DefaultRowParcel} data={task?.subtask_operation_on_parcel}
          setRowsPerPage={setRowsPerPage}
          rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
            rowsPerPage={rowsPerPage}
            currentPage={page}
            countTotal={totalCount}
             />
        </Grid>
      </Grid>
    </Dialog>
  );
}

